import { z } from 'zod';
import { emptyNull, localStorageGetItem, pipe } from '../../../shared/misc';

const LOGIN_INFO_KEY = 'vmUser';

// we superficially validate if item is a login info:
const validate = z
  .object({
    id: z.number()
  })
  .passthrough().parse;

export const loginInfoToStorage = (loginData = emptyNull) => {
  localStorage.setItem(LOGIN_INFO_KEY, JSON.stringify(loginData));
};

export const loginInfoFromStorage = () => {
  try {
    return pipe(localStorageGetItem, JSON.parse, validate)(LOGIN_INFO_KEY);
  } catch {
    return null;
  }
};
